import { ReactNode } from 'react';
import styled from 'styled-components';
import { plusHalf } from 'ui/theme/spacing';

type Props = {
  /** Content displayed within the accordian if it is open */
  children: ReactNode;
};

const AccordionBodyContainer = styled.div`
  padding: 0 ${plusHalf} ${plusHalf} ${plusHalf};
`;

/**
 * @deprecated
 * this accordion implementation has been deprecated. please use ui/AccordionContent in addition to ui/Accordion
 * */
const AccordionBodyDeprecated = ({ children, ...props }: Props) => (
  <AccordionBodyContainer {...props}>{children}</AccordionBodyContainer>
);

export default AccordionBodyDeprecated;
